import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Divider,
  Alert,
} from '@mui/material';

const Settings: React.FC = () => {
  const [apiUrl, setApiUrl] = useState(process.env.REACT_APP_API_URL || 'http://localhost:3001/api');
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [notifications, setNotifications] = useState(true);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const handleSave = () => {
    // In a real app, you would save these settings to localStorage or backend
    localStorage.setItem('apiUrl', apiUrl);
    localStorage.setItem('autoRefresh', autoRefresh.toString());
    localStorage.setItem('notifications', notifications.toString());
    setSaveSuccess(true);
    setTimeout(() => setSaveSuccess(false), 3000);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      {saveSuccess && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Settings saved successfully!
        </Alert>
      )}

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          API Configuration
        </Typography>
        <TextField
          fullWidth
          label="API Base URL"
          value={apiUrl}
          onChange={(e) => setApiUrl(e.target.value)}
          margin="normal"
          helperText="The base URL for your backend API"
        />
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h6" gutterBottom>
          Application Settings
        </Typography>
        
        <FormControlLabel
          control={
            <Switch
              checked={autoRefresh}
              onChange={(e) => setAutoRefresh(e.target.checked)}
            />
          }
          label="Auto-refresh recordings list"
        />
        
        <FormControlLabel
          control={
            <Switch
              checked={notifications}
              onChange={(e) => setNotifications(e.target.checked)}
            />
          }
          label="Enable notifications"
        />
        
        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{ mr: 2 }}
          >
            Save Settings
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setApiUrl(process.env.REACT_APP_API_URL || 'http://localhost:3001/api');
              setAutoRefresh(true);
              setNotifications(true);
            }}
          >
            Reset to Defaults
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Settings; 